import { z } from "zod";

export interface ApiError {
  code?: string;
  message?: string;
}

// Both live error shapes expose `{ error: { code, message } }`: an ApiCallError
// instance (thrown by `edenData`) and a raw `{ ok: false, error }` JSON body
// (from `authedFetch`). Parse rather than cast.
const ApiErrorEnvelope = z.object({
  error: z.object({ code: z.string().optional(), message: z.string().optional() }).optional(),
});

export function getApiError(err: unknown): ApiError | undefined {
  return ApiErrorEnvelope.safeParse(err).data?.error;
}

export const BILLING_ERROR_CODES = {
  SubscriptionExpired: "SUBSCRIPTION_EXPIRED",
  SeatCapReached: "SEAT_CAP_REACHED",
  IdempotencyKeyMismatch: "IDEMPOTENCY_KEY_MISMATCH",
  TooManyPendingOrders: "TOO_MANY_PENDING_ORDERS",
  PendingOrderExists: "PENDING_ORDER_EXISTS",
  PersistFailed: "PERSIST_FAILED",
  AddonRequiresPaidPlan: "ADDON_REQUIRES_PAID_PLAN",
  AddonQtyDecreaseNotAllowed: "ADDON_QTY_DECREASE_NOT_ALLOWED",
  NoRemainingTerm: "NO_REMAINING_TERM",
  InvalidTotal: "INVALID_TOTAL",
  PaymentProviderError: "PAYMENT_PROVIDER_ERROR",
} as const;

export type BillingErrorCode = (typeof BILLING_ERROR_CODES)[keyof typeof BILLING_ERROR_CODES];
